module.exports = __webpack_public_path__ + "static/media/proyecciones.46426328.svg";